import React, { ReactNode } from "react";
import Button, { StyledDefaultButton } from "common/Buttons/Button";
import Tooltip from "antd/es/tooltip";
import Spin from "antd/es/spin";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";

interface IconActionButtonProps {
  icon: ReactNode;
  onClick?: () => void;
  actionName: string;
  disabled?: boolean;
  loading?: boolean;
  secondaryButton?: boolean;
}

const IconActionButton = ({
  icon,
  onClick,
  actionName,
  loading,
  disabled,
  secondaryButton,
}: IconActionButtonProps) => {
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);

  const ButtonComponent = secondaryButton ? StyledDefaultButton : Button;

  return (
    <Tooltip title={actionName} trigger={isMobile ? [] : ["hover"]}>
      <ButtonComponent
        onClick={onClick}
        aria-label={actionName}
        $error={disabled}
        style={{
          width: BUTTON_SIZE,
          height: BUTTON_SIZE,
          padding: 4,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {loading ? <Spin spinning={loading} size="small" /> : icon}
      </ButtonComponent>
    </Tooltip>
  );
};

export default IconActionButton;

const BUTTON_SIZE = 32;
